import api from "../api";

export const ACTION_TYPES = {
    CLEAN_USER_PROFILE: 'CLEAN_USER_PROFILE',
    FETCH_INDIRECT_DASHBOARD: 'FETCH_INDIRECT_DASHBOARD',
    FETCH_INDIRECT_LIST: 'FETCH_INDIRECT_LIST',
    FETCH_BRANCH_OFFICE_LIST: 'FETCH_BRANCH_OFFICE_LIST',
    RESULT_UPLOAD_INVOICE: 'RESULT_UPLOAD_INVOICE',
    FETCH_INVOICE_HISTORY: 'FECTH_INVOICE_HISTORY',
    FETCH_ORDER_DETAIL_INDIRECT: 'FETCH_ORDER_DETAIL_INDIRECT',
    FETCH_REJECTED_INVOICE: 'FETCH_REJECTED_INVOICE',
    RESULT_UPLOAD_COMPLEMENT: 'RESULT_UPLOAD_COMPLEMENT',
    FETCH_INVOICE_COMPLEMENT: 'FETCH_INVOICES_COMPLEMENT',
}


export const fetch_Indirect_Dashboard = (lang, token, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchDashboard(lang, token, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INDIRECT_DASHBOARD,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Indirect_List = (lang, token, status, startDate, endDate, filterText, branchOfficeId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchOCByStatus(lang, token, status, startDate, endDate, filterText, branchOfficeId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INDIRECT_LIST,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Branch_Office_list = (lang, token, onError, onSuccess) => dispatch => {
    api.Indirect().fetchBranchOffices(lang, token)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_BRANCH_OFFICE_LIST,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const Add_Branch_Office_To_Order = (lang, token, branchOfficeId, orderId, onError, onSuccess) => dispatch => {
    api.Indirect().AddBranchOfficeToOrder(lang, token, branchOfficeId, orderId)
        .then(response => {
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Order_Detail = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchOrderDetails(lang, token, orderId)
        .then(response => {
            dispatch({
                type: 'FETCH_ORDER_DETAIL_INDIRECT',
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

//Invoices
export const Update_Invoice = (lang, token, orderId, files, onError, onSuccess) => dispatch => {
    api.Indirect().uploadInvoice(lang, token, orderId, files)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_INVOICE,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_History = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchInvoiceHistory(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_HISTORY,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const fetch_Rejected_Invoice = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchRejectedInvoice(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_REJECTED_INVOICE,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

export const delete_Rejected_Invoice = (lang, token, invoiceId, onSuccessDelete, onError) => dispatch => {
    api.Indirect().DeleteRejectedInvoice(lang, token, invoiceId)
        .then(response => {
            onSuccessDelete()
        })
        .catch(err => onError(err))
}


//Complements

export const Update_Complement = (lang, token, orderId, file, onError, onSuccess) => dispatch => {
    api.Indirect().UploadComplement(lang, token, orderId, file)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.RESULT_UPLOAD_COMPLEMENT,
                payload: response.data
            })
            onSuccess(response.data)
        })
        .catch(err => onError(err))
}

export const fetch_Invoice_Complement = (lang, token, orderId, onError, onSuccess) => dispatch => {
    api.Indirect().fetchInvoiceComplement(lang, token, orderId)
        .then(response => {
            dispatch({
                type: ACTION_TYPES.FETCH_INVOICE_COMPLEMENT,
                payload: response.data
            })
            onSuccess()
        })
        .catch(err => onError(err))
}

